/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"], n = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"], t = "Années", o = "Année", r = "Mois", s = "Semaine", c = "Jours", a = "Jour", d = "Aujourd'hui", i = "Aucun événement", u = "Jour entier", m = "Supprimer", v = "Créer un événement", M = "dddd D MMMM YYYY", l = {
  weekDays: e,
  months: n,
  years: t,
  year: o,
  month: r,
  week: s,
  days: c,
  day: a,
  today: d,
  noEvent: i,
  allDay: u,
  deleteEvent: m,
  createEvent: v,
  dateFormat: M
};
export {
  u as allDay,
  v as createEvent,
  M as dateFormat,
  a as day,
  c as days,
  l as default,
  m as deleteEvent,
  r as month,
  n as months,
  i as noEvent,
  d as today,
  s as week,
  e as weekDays,
  o as year,
  t as years
};
